import { RichContent } from "./../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { createParagraphNode, createTextNode, initializeMetadata } from "../../nodeUtils.js";
const fromPlainText = (text) => {
  const paragraphs = text.split("\n").map(
    (paragraph) => createParagraphNode(paragraph ? [createTextNode(paragraph)] : [])
  );
  const content = {
    nodes: paragraphs,
    metadata: initializeMetadata()
  };
  return RichContent.fromJSON(content);
};
export {
  fromPlainText
};
//# sourceMappingURL=fromPlainText.js.map
